import { render, staticRenderFns } from "./modal-course-import.vue?vue&type=template&id=0ff5c10c&scoped=true"
import script from "./modal-course-import.vue?vue&type=script&lang=js"
export * from "./modal-course-import.vue?vue&type=script&lang=js"
import style0 from "./modal-course-import.vue?vue&type=style&index=0&id=0ff5c10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff5c10c",
  null
  
)

export default component.exports